<template>
  <div class="productPage">
    <div class="productPageGrid">

      <div class="desktop"></div>

      <div class="content">
        <img class="showcase" :src="productCover" />
      </div>

      <div class="infoCard">
        <div class="container">

          <div class="productTitle">
            <b> {{ product.name }}</b>
            <br>
            {{ product.cnName }}
          </div>

          <div class="productInfo">
            <b>NT${{ product.price }}</b>
            <br>
            <div v-html="product.description"></div>
          </div>
        </div>
      </div>

      <div class="desktop"></div>

			<div class="mobile">
				<carousel class="carouselWrapper" :per-page="1" :mouse-drag="true" :paginationSize="14" :paginationPadding="6">
				<slide class="slideWrapper" v-for="image in product.images" :key="image.id">
				<img :src="getProductImage(image)">
				</slide>
				</carousel>
      </div>


    </div>

    <div class="posters desktop">
      <div class="imageWrapper" v-for="image in product.images" :key="image.id">
        <img :src="getProductImage(image)" @click="changeDisplayImage(image)">
      </div>
    </div>

  </div>
</template>

<script>
import Styles from "./styles.scss";
import { Carousel, Slide } from 'vue-carousel';

export default {
  name: "ProductPage",
  props: ["productId"],
  data() {
    return {
      amount: 1,
      displayedImage: "main.jpg",
      Styles,
    };
  },
  components: {
    Carousel, 
    Slide
  }, 
  computed: {
    product() {
      let data = {
        ...this.$store.getters["products/getProduct"](this.productId),
      };
      data.imgUrl = require(`@/assets/images/products/${this.productId}/${this.displayedImage}`);
      return data;
    },
    productCover(){
      return require(`@/assets/images/products/${this.productId}/main.jpg`);
    }
  },
  methods: {
    // incrementAmount() {
    //   this.amount = Math.min(this.amount + 1, 10);
    // },
    // subtractAmount() {
    //   this.amount = Math.max(this.amount - 1, 1);
    // },
    // addToCart() {
    //   this.$store.dispatch("products/addToCart", {
    //     productId: this.productId,
    //     addAmount: this.amount,
    //   });
    //   this.amount = 1;
    // },
    getProductImage(filename){
      return require(`@/assets/images/products/${this.productId}/${filename}`);
    }, 
    changeDisplayImage(filename){
      this.displayedImage = filename;
    }
  },
};
</script>
